import { apiBaseUrl } from '$lib/api-base-url';

import type { CreateClientConfig } from './api/client.gen';

export const createClientConfig: CreateClientConfig = (config) => ({
	...config,
	baseUrl: apiBaseUrl,
});
